import InTotalYouHaveSaved from "@/components/inTotalYouHaveSaved/inTotalYouHaveSaved.vue";
import TotalGuestSavings from "@/components/totalGuestSavings/totalGuestSavings.vue";
import MonthlySavings from "@/components/monthlySavings/monthlySavings.vue";
import MyGoalsTotalSavings from "@/components/myGoalsTotalSavings/myGoalsTotalSavings.vue";
import ChangeBaselineModal from "@/components/changeBaselineModal/changeBaselineModal.vue";
import { createNamespacedHelpers } from "vuex";
import { REQUEST_STATE } from "@/enums";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	components: {
		ChangeBaselineModal,
		InTotalYouHaveSaved,
		TotalGuestSavings,
		MonthlySavings,
		MyGoalsTotalSavings,
	},

	data() {
		return {
			showChangeBaselineModal: false,
			dataStatus: [REQUEST_STATE.LOADING, REQUEST_STATE.LOADING, REQUEST_STATE.LOADING],
			weightTotal: null,
			weightTotalDiff: null,
			costTotal: null,
			costTotalDiff: null,
			weightWPG: null,
			weightWPGDiff: null,
			costWPG: null,
			costWPGDiff: null,
		};
	},

	computed: {
		...userGetters(["activeOutlet"]),
		readyToPrint,
	},

	methods: {
		onChangeBaseline,
		notifyLoaded,
		printPage,
		loadedDataTotal,
		loadedDataWPG,
	},
};

function onChangeBaseline() {
	this.showChangeBaselineModal = false;
	location.reload();
}

function notifyLoaded(num, state) {
	this.dataStatus[num] = state;
	// remind Vue to track the change...
	this.dataStatus = { ...this.dataStatus };
}

function printPage() {
	this.$utils.printPage(this);
}

function readyToPrint() {
	return Object.values(this.dataStatus)
		.map((status) => status === REQUEST_STATE.SUCCESS)
		.every(Boolean);
}

function loadedDataTotal(w, wDiff, c, cDiff) {
	this.weightTotal = w;
	this.weightTotalDiff = wDiff;
	this.costTotal = c;
	this.costTotalDiff = cDiff;
}

function loadedDataWPG(w, wDiff, c, cDiff) {
	this.weightWPG = w;
	this.weightWPGDiff = wDiff;
	this.costWPG = c;
	this.costWPGDiff = cDiff;
}
